import { useState, useEffect, useRef } from 'react';
import { validateEmail } from '../../../Utils/Validation';
import { useTheme } from '../../../GlobalContext/GlobalContext';
import { useNavigate } from 'react-router-dom';
import { getData, postData } from '../../../ApiServices/ApiService';
import {
  ORG_DELETE_CLIENT_TASK, ORG_SCHEDULE_PRIORITY_LIST_DASHBOARD, ORG_TODO_SCHEDULE_LIST_DASHBOARD,
  ORG_GET_PENDING_TASK_LIST, ORG_DELETE_TO_DO_ITEM, ORG_UPCOMING_APPOINTMENT_DASHBOARD, ORG_GET_TASKS_OVERVIEW_DASHBOARD, ORG_GET_NOTIFICATIONS_LIST_DASHBOARD, ORG_GET_ACTIVITY_REPORT,
} from '../../../ApiServices/BaseURL';
import { getCurrentFormattedDate } from '../../../Utils/Validation';
import { logFrontendException } from '../../../Utils/Exception';

const useDashboardController = (refreshDashboard, setRefreshDashboard) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const screenName = 'DashboardScreen';
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [scheduleTypeError, setScheduleTypeError] = useState('');
  const [scheduleTypesLoading, setScheduleTypesLoading] = useState(false);
  const [scheduleTpyeList, setScheduleTypeList] = useState([]);
  const [isToDoModalOpen, setIsToDoModalOpen] = useState(false);
  const [scheduleToDoLoading, setScheduleToDoLoading] = useState(false);
  const [scheduleToDoError, setScheduleToDoError] = useState('');
  const [scheduleToDoList, setScheduleToDoList] = useState([]);
  const [toDoInfoState, setToDoInfoState] = useState('');
  const [pendingTasksList, setPendingTasksList] = useState([]);
  const [pendingTasksResError, setPendingTasksResError] = useState('');
  const [pendingTasksLoading, setPendingTasksLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const taskInfoRef = useRef(null);
  const [deleteTaskLoading, setDeleteTaskLoading] = useState({});
  const [deleteTaskError, setDeleteTaskError] = useState({});
  const [deleteTaskSuccess, setDeleteTaskSuccess] = useState({});
  const { setIsLoginPopup } = useTheme();
  const [isDeleteToDoModalOpen, setIsDeleteToDoModalOpen] = useState(false)
  const [deleteToDoItemLoading, setDeleteToDoItemLoading] = useState({})
  const [deleteToDoItemError, setDeleteToDoItemError] = useState({})
  const [deleteToDoItemSuccess, setDeleteToDoItemSuccess] = useState({})
  const toDoItemRef = useRef(null);
  const [upcomingInfoState, setUpcomingInfoState] = useState('');

  const [taskOverview, setTaskOverview] = useState([
    { label: "Completed", key: 'completed', value: "", trend: 'up' },
    { label: "Pending", key: 'pending', value: "", trend: 'down' },
    { label: "Priority", key: 'priority', value: "", trend: 'up' },
    { label: "Not Started", key: 'not_started', value: "", trend: 'up' }
  ])
  const [taskOverviewError, setTaskOverviewError] = useState('');
  const [taskOverviewLoading, setTaskOverviewLoading] = useState(false);

  const [activityReportError, setActivityReportError] = useState('');
  const [activityReportLoading, setActivityReportLoading] = useState(false);
  const [activityReport, setActivityReport] = useState([]);
  const [activity, setActivity] = useState('Last 7 days');
  const [percentage, setPercentage] = useState(0);

  const pageName = 'useDashboardController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;


  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserInfo(storedUserInfo);
  }, []);

  useEffect(() => {
    fetchPriorityList();
    fetchToDoList();
    fetchUpcomingAppointemntsList();
    fetchPendingTaskList();
    fetchTaskOverview();
    fetchNotificationstsList();
  }, [])

  useEffect(() => {
    if (refreshDashboard) {
      fetchPriorityList();
      fetchToDoList();
      setRefreshDashboard(false);
    }
  }, [refreshDashboard]);

  const sampleNotifications = [
    { message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
    { message: "Curabitur accumsan turpis pharetra augue tincidunt." },
    { message: "Pellentesque habitant morbi tristique senectus et netus." },
    { message: "Suspendisse potenti. Sed porttitor lectus nibh." }
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to navigate to the next notification
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % notificationList?.length);
  };

  // Function to navigate to the previous notification
  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      (prevIndex - 1 + notificationList?.length) % notificationList?.length
    );
  };

  // Function to truncate notification if it exceeds 100 characters
  const getTruncatedNotification = (notification) => {
    return notification?.nb_message.length > 100 ? `${notification?.nb_message.substring(0, 100)}...` : notification?.nb_message;
  };
  const handleSheduleAndReminder = () => {
    // navigate('/schedule-reminder');return
    setSelectedUpcomingData(null)
    setIsScheduleModalOpen(true);
  }

  const handleCloseScheduleDoModal = () => {
    //console.log("Closing Schedule Modal");
    setIsScheduleModalOpen(false);
  };



  const sampleTaskOverview = [
    { task_status: "Completed", count: 1203, trend: 'up' },
    { task_status: "Pending", count: 21, trend: 'down' },
    { task_status: "Priority", count: '04', trend: 'up' },
    { task_status: "Not Started", count: 34, trend: 'up' }
  ];
  const pendingTasksData = [
    {
      client: "Sierra Ferguson",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson1",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson2",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson3",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson4",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson5",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson6",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson7",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson8",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    {
      client: "Sierra Ferguson9",
      phone: "+91 (99) 436-46-15",
      task: "GST Filling, E-Tax File",
      dueDate: "Nov 25, 2024",
    },
    // Add more sample data as needed
  ];

  const todosData = [
    {
      description: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet...",
      dueDate: "Nov 25, 2024",
    },
    {
      description: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet...",
      dueDate: "Nov 25, 2024",
    },
    {
      description: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet...",
      dueDate: "Nov 25, 2024",
    },
    {
      description: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet...",
      dueDate: "Nov 25, 2024",
    },
    {
      description: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet...",
      dueDate: "Nov 25, 2024",
    },
    // Add more sample data as needed
  ];

  const fetchPendingTaskList = async () => {
    try {
      setPendingTasksLoading(true);
      setPendingTasksResError('');
      setPendingTasksList([])
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_PENDING_TASK_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&emp_id=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setPendingTasksList(responseData?.dataJ);
            } else {
              setPendingTasksResError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchPendingTaskList", responseData?.info || '');
            }
          } else {
            setPendingTasksResError(responseData?.info || 'Failed to fetch priority list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchPendingTaskList", responseData?.info || '');
          }
        } else {
          setPendingTasksResError(responseData?.info || 'Failed to fetch  priority list.');
          logFrontendException(storedUserId, pageName, "fetchPendingTaskList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setPendingTasksResError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchPendingTaskList", responseData || '');
          setIsLoginPopup(true)
        
      }
      
      // Unexpected or network-related errors
      else {
        setPendingTasksResError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchPendingTaskList", responseData || '');
      }
    } catch (error) {
     
        setPendingTasksResError(`Failed to  priority list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchPendingTaskList-catch", error || '');
      
    } finally {
      setPendingTasksLoading(false);
    }
  }
  const ItemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(pendingTasksList.length / ItemsPerPage);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * ItemsPerPage;
  const indexOfFirstItem = indexOfLastItem - ItemsPerPage;

  // Slice the data for the current page
  const currentTasks = pendingTasksList.slice(indexOfFirstItem, indexOfLastItem);




  const quickActions = [
    { label: 'Post Time Sheet' },
    { label: 'Leave/Attendance' },
    { label: 'Add Expense' },
    { label: 'Add Notes' },
    { label: 'Create Task', isActive: true },
  ];
  const appointments = [
    {
      id: 1,
      name_of_person: 'Amitabh Kanth',
      company: 'Nelsa Web LLC',
      date_of_schedule: 'Monday, Oct 14th, 6:30 PM',
      status: 'In Progress',
      statusColor: '#D1FAE5',
      textColor: '#059669'
    },
    {
      id: 2,
      name_of_person: 'Srikanth Reddy Venna',
      company: 'Datascale Pvt. Ltd.',
      date_of_schedule: 'Monday, Oct 14th, 6:30 PM',
      status: 'Start in 1 hour',
      statusColor: '#FEF3C7',
      textColor: '#D97706'
    },
    {
      id: 3,
      name_of_person: 'Srinivas Arutla',
      company: 'Media Channel Ltd.',
      date_of_schedule: 'Monday, Oct 14th, 6:30 PM',
      status: 'Overdue',
      statusColor: '#FECACA',
      textColor: '#DC2626'
    },
    {
      id: 4,
      name_of_person: 'Manish Singh',
      company: 'Corlax Company Ltd.',
      date_of_schedule: 'Monday, Oct 14th, 6:30 PM',
      status: 'Reschedule',
      statusColor: '#E0E7FF',
      textColor: '#4F46E5'
    },
  ];
  const [selectedOption, setSelectedOption] = useState('Follow ups'); // Default selected option
  const options = ['Follow ups', 'Appointments', 'Meeting'];
  const dateOptions = ['Last 7 days', 'Last 15 days'];
  const [clientData, setClientData] = useState({
    clientName: '',
    clientType: '',
    identificationType: '',
    identificationNumber: '',
    groupClient: '',
    mobileNumber: '',
    existingClient: false,
  });

  // Function to handle all values from AddClientModal
  const handleAddClient = (data) => {
    setClientData(data); // Update the state with all data at once
    //console.log('Client Data:', data); // For debugging
  };
  const [selecteTabledOption, setSelectedTableOption] = useState("ToDo's");
  const handleAppointments = (appointment) => {
    navigate('/schedule-reminder')
  }

  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [taskInfo, setTaskInfo] = useState(null)
  const [isAddToDoModalOpen, setIsAddToDoModalOpen] = useState(false);
  const [isAddToDoRadioButtonModalOpen, setIsAddToDoRadioButtonModalOpen] = useState(false);
  const [isScheduleAppointmentCompleteModalOpen, setIsScheduleAppointmentCompleteModalOpen] = useState(false);

  const handleAddCommentModal = (taskData) => {
    setIsCommentModalOpen(true); // Open the modal
    setTaskInfo(taskData)
  };

  const commentSuccess = () => {
    fetchPendingTaskList();
  }

  const handleEditPendingTask = (taskInfo) => {
    navigate(`/manage-clients`, { state: { task: 'Tasks', clientId: taskInfo?.client_id, taskInfo: taskInfo } }); // Pass task in state
  }

  const handleCloseCommentModal = () => {
    setIsCommentModalOpen(false); // Close the modal
  };

  const handleAddToDoModal = () => {
    setSelectedDocument(null)
    setIsAddToDoModalOpen(true); // Open the modal
  };

  const handleCloseToDoModal = () => {
    //console.log("Closing To-Do Modal");
    setIsAddToDoModalOpen(false); // Close the modal
  };

  const handleAddToDoRadioButtonModal = (toDoInfo) => {
    setIsAddToDoRadioButtonModalOpen(true);
    setToDoInfoState(toDoInfo)
  };
  const handleCloseToDoRadioButtonModal = () => {
    setIsAddToDoRadioButtonModalOpen(false);
  };

  const handleAddScheduleAppointmentCompleteModal = (upcoming) => {
    setUpcomingInfoState(upcoming);
    setIsScheduleAppointmentCompleteModalOpen(true)
  }

  const handleCloseScheduleAppointmentCompleteModal = () => {
    setIsScheduleAppointmentCompleteModalOpen(false)
  }

  const [selectedDocument, setSelectedDocument] = useState(null);
  const handleEditToDo = (ToDo) => {
    setSelectedDocument(ToDo);
    setIsAddToDoModalOpen(true);
  };

  const [selectedUpcomingData, setSelectedUpcomingData] = useState(null)
  const handleEditUpcomingEdit = (ToDo) => {
    setSelectedUpcomingData(ToDo);
    setIsScheduleModalOpen(true);
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 16) return 'Good Afternoon';
    return 'Good Evening';
  };

  const fetchTaskOverview = async () => {
    try {
      setTaskOverviewLoading(true);
      setTaskOverviewError('');

      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_TASKS_OVERVIEW_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}&date=${getCurrentFormattedDate()}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const overViewReport = taskOverview.map((task) => ({
                ...task,
                value: responseData?.dataJ[0][task.key] ?? "--",
              }));
              setTaskOverview(overViewReport);
            } else {
              setTaskOverviewError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchTaskOverview", responseData?.info || '');
            }
          } else {
            setTaskOverviewError(responseData?.info || 'Failed to fetch task overview. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchTaskOverview", responseData?.info || '');
          }
        } else {
          setTaskOverviewError(responseData?.info || 'Failed to fetch task overview.');
          logFrontendException(storedUserId, pageName, "fetchTaskOverview", responseData?.info || '');
        }
      }
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setTaskOverviewError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchTaskOverview", responseData || '');
          setIsLoginPopup(true)
      }
      
      else {
        setTaskOverviewError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchTaskOverview", responseData || '');
      }
    } catch (error) {
      
        setTaskOverviewError(`Failed to fetch task overview. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchTaskOverview-catch", error || '');
      
    } finally {
      setTaskOverviewLoading(false);
    }
  }

  const fetchPriorityList = async () => {
    try {
      setScheduleTypesLoading(true);
      setScheduleTypeError('');
      setScheduleTypeList([])
      // setTeamInfo({});
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_SCHEDULE_PRIORITY_LIST_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}&emp_id=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const fetchedList = responseData?.dataJ
              setScheduleTypeList(fetchedList);
              // selTeamInfo.current = responseData?.dataJ[0];
            } else {
              setScheduleTypeError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchPriorityList", responseData?.info || '');
            }
          } else {
            setScheduleTypeError(responseData?.info || 'Failed to fetch priority list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchPriorityList", responseData?.info || '');
          }
        } else {
          setScheduleTypeError(responseData?.info || 'Failed to fetch  priority list.');
          logFrontendException(storedUserId, pageName, "fetchPriorityList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setScheduleTypeError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchPriorityList", responseData || '');
        
        setIsLoginPopup(true)
      }
      
      // Unexpected or network-related errors
      else {
        setScheduleTypeError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchPriorityList", responseData || '');
      }
    } catch (error) {
       
        // An error occurred in setting up the request
        setScheduleTypeError(`Failed to  priority list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchPriorityList-catch", error || '');
      
    } finally {
      setScheduleTypesLoading(false);
    }
  }

  const fetchToDoList = async () => {
    try {
      setScheduleToDoLoading(true);
      setScheduleToDoError('');
      setScheduleToDoList([])
      // setTeamInfo({});
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_TODO_SCHEDULE_LIST_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}&emp_id=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const fetchedList = responseData?.dataJ
              setScheduleToDoList(fetchedList);
              // selTeamInfo.current = responseData?.dataJ[0];
            } else {
              setScheduleToDoError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
            }
          } else {
            setScheduleToDoError(responseData?.info || 'Failed to fetch  todo list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
          }
        } else {
          setScheduleToDoError(responseData?.info || 'Failed to fetch todo list.');
          logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setScheduleToDoError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
        logFrontendException(storedUserId, pageName, "fetchTodoList", responseData || '');
        setIsLoginPopup(true)
      }
     
      else {
        setScheduleToDoError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchTodoList", responseData || '');
      }
    } catch (error) {
     
        setScheduleToDoError(`Failed to fetch todo list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchTodoList-catch", error || '');
      
    } finally {
      setScheduleToDoLoading(false);
    }
  }

  const [upcomingLoading, setUpcomingoading] = useState(false);
  const [upcomingError, setUpcomingError] = useState('');
  const [upcomingList, setUpcomingList] = useState([]);

  const fetchUpcomingAppointemntsList = async () => {
    try {
      setUpcomingoading(true);
      setUpcomingError('');
      setUpcomingList([])
      // setTeamInfo({});
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_UPCOMING_APPOINTMENT_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}&emp_id=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const fetchedList = responseData?.dataJ
              setUpcomingList(fetchedList);
              // selTeamInfo.current = responseData?.dataJ[0];
            } else {
              setUpcomingError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList", responseData?.info || '');
            }
          } else {
            setUpcomingError(responseData?.info || 'Failed to fetch  todo list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList", responseData?.info || '');
          }
        } else {
          setUpcomingError(responseData?.info || 'Failed to fetch todo list.');
          logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setUpcomingError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList", responseData || '');
          setIsLoginPopup(true)
      }
     
      // Unexpected or network-related errors
      else {
        setUpcomingError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList", responseData || '');
      }
    } catch (error) {
      
        setUpcomingError(`Failed to fetch todo list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchUpcomingAppointemntsList-catch", error || '');
    } finally {
      setUpcomingoading(false);
    }
  }


  const [currentUpcomingPage, setCurrentUpcomingPage] = useState(1);
  const totalUpcomingPages = Math.ceil(upcomingList?.length / ItemsPerPage);

  // Function to handle page change
  const handleUpcomingPageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalUpcomingPages) {
      setCurrentUpcomingPage(pageNumber);
    }
  };

  // Calculate the index of the first and last items on the current page
  const indexOfUpcomingLastItem = currentUpcomingPage * ItemsPerPage;
  const indexOfUpcomingFirstItem = indexOfUpcomingLastItem - ItemsPerPage;

  // Slice the data for the current page
  const currentUpcomingTasks = upcomingList?.slice(indexOfUpcomingFirstItem, indexOfUpcomingLastItem);

  const getStatusStyle = (status) => {
    const statusName = status?.toLowerCase();
    switch (statusName) {
      case "new":
        return { backgroundColor: "#0EA5E91A", color: "#0369A1"}; // New: Light Teal with Blue text
      case "in progress":
        return { backgroundColor: "#10B9811A", color: "#047857"}; // In Progress: Light Green with Dark Green text
        case "completed":
        return { backgroundColor: "#8B5CF61A", color: "#6D28D9"}; // Completed: Light Violet with Purple text
      case "overdue":
        return { backgroundColor: "#FFE4E6", color: "#BE123C"}; // Overdue: Light Red with Dark Red text
      case "start in 1 hour":
        return { backgroundColor: "#E2B1332E", color: "#DFA510"}; // Starts in One Hour: Light Orange with Dark Orange text
      case "reschedule":
        return { backgroundColor: "#E2B1332E", color: "#DFA510"}; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
      case "attended":
        return { backgroundColor: "#8B5CF61A", color: "#6D28D9"}; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
      case "not attended":
        return { backgroundColor: "#E6E8EC", color: "#000"}; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
  
      
      default:
        return { backgroundColor: "#FFFFFF", color: "#000"}; // Default to white with black text if no status matches
    }
  };




  const [currentPageToDoList, setCurrentPageToDoList] = useState(1);

  const totalPagesToDoList = Math.ceil(scheduleToDoList.length / ItemsPerPage);

  // Function to handle page change
  const handleToDoPageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPagesToDoList) {
      setCurrentPageToDoList(pageNumber);
    }
  };

  // Calculate the index of the first and last items on the current page
  const indexOfLastItemToDo = currentPageToDoList * ItemsPerPage;
  const indexOfFirstItemToDo = indexOfLastItemToDo - ItemsPerPage;

  // Slice the data for the current page
  const currentScheduleToDoList = scheduleToDoList.slice(
    indexOfFirstItemToDo,
    indexOfLastItemToDo
  );

  const onTaskDelete = async (taskInfo) => {
    //console.log('taskInfo:-', taskInfo?.task_id);
    taskInfoRef.current = taskInfo;
    setIsDeleteModalOpen(true);
  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
  }

  const callDeleteTask = async (taskInfo) => {
    try {
      setDeleteTaskError({});
      setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: '' }));
      setDeleteTaskLoading((prev) => ({ ...prev, [taskInfo?.task_id]: true }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "task_id": taskInfo?.task_id
      }

      //console.log('callDeleteTask payload', payLoad);

      // Make the API call
      const response = await postData(ORG_DELETE_CLIENT_TASK, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteTaskSuccess((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info }));
            setTimeout(() => {
              setDeleteTaskSuccess((prev) => ({ ...prev, [taskInfo?.task_id]: '' }));
              fetchPendingTaskList();
            }, 3000);
          } else {
            setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info || 'Failed to delete task. Please try again.' }));
            logFrontendException(storedUserId, pageName, "callDeleteTask", responseData?.info || '');
          }
        } else {
          setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info || 'Failed to delete task. Please try again...' }));
          logFrontendException(storedUserId, pageName, "callDeleteTask", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.' }));
        logFrontendException(storedUserId, pageName, "callDeleteTask", responseData || '');
        setIsLoginPopup(true)
      }
     
      // Unexpected or network-related errors
      else {
        setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "callDeleteTask", responseData || '');
      }
    } catch (error) {
    
        setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: `Failed to delete task. Please check your network connection and try again.` }));
      logFrontendException(storedUserId, pageName, "callDeleteTask-catch", error || '');
    } finally {
      setDeleteTaskLoading((prev) => ({ ...prev, [taskInfo?.task_id]: false }));
    }
  }

  const onToDoItemDelete = async (todoItem) => {
    //console.log('taskInfo:-', todoItem?.sc_id);
    toDoItemRef.current = todoItem;
    setIsDeleteToDoModalOpen(true);
  }

  const handleCloseToDoDeleteModal = () => {
    setIsDeleteToDoModalOpen(false); // Close the modal
  }

  const callDeleteToDoItem = async (todoItem) => {
    try {
      setDeleteToDoItemError({});
      setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: '' }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "sc_id": todoItem?.sc_id
      }

      //console.log('callDeleteTask payload', payLoad);
      // return

      setDeleteToDoItemLoading((prev) => ({ ...prev, [todoItem?.sc_id]: true }));
      // Make the API call
      const response = await postData(ORG_DELETE_TO_DO_ITEM, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteToDoItemSuccess((prev) => ({ ...prev, [todoItem?.sc_id]: responseData?.info }));
            setTimeout(() => {
              setDeleteToDoItemSuccess((prev) => ({ ...prev, [todoItem?.sc_id]: '' }));
              fetchToDoList();
              fetchPriorityList();
            }, 3000);
          } else {
            setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: responseData?.info || 'Failed to delete task. Please try again.' }));
            logFrontendException(storedUserId, pageName, "callDeleteToDoItem", responseData?.info || '');
          }
        } else {
          setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: responseData?.info || 'Failed to delete task. Please try again...' }));
          logFrontendException(storedUserId, pageName, "callDeleteToDoItem", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
       
          setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
          logFrontendException(storedUserId, pageName, "callDeleteToDoItem", responseData || '');
          setIsLoginPopup(true)
        
      }
     
      else {
        setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "callDeleteToDoItem", responseData || '');
      }
    } catch (error) {
      
        setDeleteToDoItemError((prev) => ({ ...prev, [todoItem?.sc_id]: `Failed to delete task. Please check your network connection and try again.` }));
        logFrontendException(storedUserId, pageName, "callDeleteToDoItem-catch", error || '');
      
    } finally {
      setDeleteToDoItemLoading((prev) => ({ ...prev, [todoItem?.sc_id]: false }));
    }
  }

  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationError, setNotificationError] = useState('');
  const [notificationList, setNotificationList] = useState([])
  const fetchNotificationstsList = async () => {
    try {
      setNotificationLoading(true);
      setNotificationError('');
      setNotificationList([])
      // setTeamInfo({});
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_NOTIFICATIONS_LIST_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const fetchedList = responseData?.dataJ
              setNotificationList(fetchedList);
              // selTeamInfo.current = responseData?.dataJ[0];
            } else {
              setNotificationError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchNotificationstsList", responseData?.info || '');
            }
          } else {
            setNotificationError(responseData?.info || 'Failed to fetch  todo list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchNotificationstsList", responseData?.info || '');
          }
        } else {
          setNotificationError(responseData?.info || 'Failed to fetch todo list.');
          logFrontendException(storedUserId, pageName, "fetchNotificationstsList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
       
          setNotificationError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchNotificationstsList", responseData || '');
          setIsLoginPopup(true)
          // Optionally, redirect to the login page or refresh the token
       
      }
     
      // Unexpected or network-related errors
      else {
        setNotificationError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchNotificationstsList", responseData || '');
      }
    } catch (error) {
      
        setNotificationError(`Failed to fetch todo list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchNotificationstsList-catch", error || '');
      
    } finally {
      setNotificationLoading(false);
    }
  }

  const fetchActivityReport = async (action) => {
    try {
      setActivityReportLoading(true);
      setActivityReportError('');

      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_ACTIVITY_REPORT}?emp_id_auth=${storedUserInfo?.emp_id}&action_type=${action}`);
      const responseData = await response.json();

      console.log("activityReport",responseData?.dataJ);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setActivityReport(responseData?.dataJ);
              const totalPrevious = responseData?.dataJ.reduce((sum, item) => sum + item.previous, 0);
              const totalCurrent = responseData?.dataJ.reduce((sum, item) => sum + item.current, 0);
              const difference = totalCurrent - totalPrevious;
              let percentage;
              if (totalPrevious === 0) {
                percentage = totalCurrent === 0 ? 0 : 100;
              } else {
                percentage = (difference / totalPrevious) * 100;
              }
            
              setPercentage(percentage);
            } else {
              setActivityReportError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchActivityReport", responseData?.info || '');
            }
          } else {
            setActivityReportError(responseData?.info || 'Failed to fetch activity report. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchActivityReport", responseData?.info || '');
          }
        } else {
          setActivityReportError(responseData?.info || 'Failed to fetch activity report.');
          logFrontendException(storedUserId, pageName, "fetchActivityReport", responseData?.info || '');
        }
      }
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
       
          setActivityReportError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchActivityReport", responseData || '');
        
      }
  
      else {
        setActivityReportError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchActivityReport", responseData || '');
      }
    } catch (error) {
     
        setActivityReportError(`Failed to fetch activity report. Please check your network connection and try again.`);
      logFrontendException(storedUserId, pageName, "fetchActivityReport-catch", error || '');
    } finally {
      setActivityReportLoading(false);
    }
  }

  useEffect(() => {
    if (activity == "Last 7 days"){
      fetchActivityReport("7Days");
    }
    if (activity == "Last 15 days"){
    fetchActivityReport("15Days");
    }
  }, [activity]);

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])
  const handlePendingTask = (type, taskData) => {
    console.log('handlePendingTask taskData :', taskData,);
    if (taskData?.value !== '--' && taskData?.value > 0) {
      const selectedInfo = {
        selService: 0,
        selServiceCategory: 0,
        taskType: type || '',
        taskTypeName: taskData?.key || '',
        serviceCheckId: 0
      }
      navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
    }
  }

  

  return {
    loading,
    error,
    success,
    screenName,
    sampleNotifications,
    currentIndex,
    handleNext,
    handlePrevious,
    getTruncatedNotification,
    handleSheduleAndReminder,
    sampleTaskOverview,
    pendingTasksList,
    todosData,
    ItemsPerPage,
    currentPage,
    totalPages,
    handlePageChange,
    currentTasks,
    quickActions,
    appointments,
    selectedOption,
    options,
    dateOptions,
    clientData,
    handleAddClient,
    selecteTabledOption,
    handleAppointments,
    isCommentModalOpen,
    isAddToDoModalOpen,
    isAddToDoRadioButtonModalOpen,
    handleAddCommentModal,
    handleCloseCommentModal,
    handleAddToDoModal,
    handleCloseToDoModal,
    handleAddToDoRadioButtonModal,
    handleCloseToDoRadioButtonModal,
    setSelectedTableOption,
    setSelectedOption,
    getGreeting,
    userInfo,
    isScheduleModalOpen,
    handleCloseScheduleDoModal,

    scheduleTypeError,
    scheduleTypesLoading,
    scheduleTpyeList,

    scheduleToDoError,
    scheduleToDoList,
    scheduleToDoLoading,
    fetchToDoList,
    fetchPriorityList,
    handleEditToDo,
    selectedDocument,
    upcomingList,
    upcomingError,
    upcomingLoading,
    getStatusStyle,
    selectedUpcomingData,
    handleEditUpcomingEdit,
    handleToDoPageChange, currentPageToDoList, totalPagesToDoList,
    currentScheduleToDoList,
    toDoInfoState,
    pendingTasksResError,
    pendingTasksLoading, taskInfo, commentSuccess, handleEditPendingTask,
    taskInfoRef, onTaskDelete, isDeleteModalOpen,
    deleteTaskError, deleteTaskLoading, deleteTaskSuccess,
    handleCloseDeleteModal, callDeleteTask,
    taskOverview, taskOverviewLoading, taskOverviewError,
    onToDoItemDelete, handleCloseToDoDeleteModal, callDeleteToDoItem, toDoItemRef,
    deleteToDoItemLoading, deleteToDoItemError, deleteToDoItemSuccess, isDeleteToDoModalOpen,
    fetchUpcomingAppointemntsList,
    notificationList,
    notificationError,
    notificationLoading,

    currentUpcomingTasks,
    indexOfUpcomingFirstItem,
    indexOfUpcomingLastItem,
    handleUpcomingPageChange,
    totalUpcomingPages,
    currentUpcomingPage,

    isScheduleAppointmentCompleteModalOpen,
    handleCloseScheduleAppointmentCompleteModal,
    handleAddScheduleAppointmentCompleteModal,
    upcomingInfoState,
    handlePendingTask,
    userPermissions,
    activityReport,
    activityReportLoading,
    activityReportError,
    setActivity,
    activity,
    percentage,
  };
}

export default useDashboardController;